import React from "react";
import ReworkBadge, { ReworkReason } from "./ReworkBadge";

export default function TodayTaskList({
  tasks = [],
  onStart,
  onView,
  label = "today",
}) {
  if (!tasks.length) {
    return (
      <div className="panel">
        <div style={{ fontWeight: 600 }}>
          You have no tasks scheduled for {label}.
        </div>
        <div className="small-muted">
          Check with your manager if you were expecting work.
        </div>
      </div>
    );
  }

  return (
    <div className="panel">
      {tasks.map((task, index) => (
        <div key={task.id} style={{ marginBottom: 12 }}>
          <div style={{ fontWeight: 600 }}>
            {index + 1}. {task.stageName} · {task.projectName}
            <ReworkBadge task={task} />
          </div>
          <ReworkReason task={task} />
          {/* <div className="stage-assign-row">
            <button className="btn-primary" onClick={() => onStart(task)}>
              {task.status === "IN_PROGRESS" ? "Continue Working" : "Start Working"}
            </button>
            <button className="btn-secondary" onClick={() => onView(task)}>
              View Tasks
            </button>
          </div> */}
        </div>
      ))}
    </div>
  );
}
